import PasswordChangeForm from './PasswordChangeForm';

/* W-053 step 3a -- THE FORCED FIRST-LOGIN SCREEN. A login with must_change_password (a new login, or one an admin reset)
   sees only this page until it sets a new password; the server refuses every other route meanwhile (403
   MUST_CHANGE_PASSWORD). On success the new token + user are already stored (api.js changePassword) and onDone takes the
   user straight into the app. Sign out stays available. */
export default function ForcedPasswordScreen({ user, onDone, onLogout }) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f0f2f5' }}>
            <div style={{ background: '#fff', padding: 40, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', width: 420 }}>
                <h2 style={{ margin: '0 0 8px', color: '#1A1C2E' }}>Set your new password</h2>
                <p style={{ margin: '0 0 16px', color: '#666', fontSize: 14 }}>
                    {user && user.email ? <>Signed in as <strong>{user.email}</strong>. </> : null}
                    Before you continue, replace the temporary password you were given with one of your own.
                </p>
                <PasswordChangeForm currentLabel="Current (temporary) password" submitLabel="Set new password" onSuccess={onDone} />
                <div style={{ marginTop: 20, textAlign: 'center' }}>
                    <button type="button" onClick={onLogout}
                        style={{ background: 'none', border: 'none', color: '#2A6DB0', cursor: 'pointer', fontSize: 13, textDecoration: 'underline' }}>
                        Sign out
                    </button>
                </div>
            </div>
        </div>
    );
}
